module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/paulina-kozlowska-1a906ec25b51802fea6f4266adaa1aeb.png";